function injectStyle (ssrContext) {
  require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-30542548\",\"scoped\":true,\"hasInlineConfig\":false}!less-loader?{\"sourceMap\":true}!./Main.controller.less")
}
var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./Main.controller.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-30542548\",\"hasScoped\":true}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Main.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-30542548",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Main.vue
// module id = 514
// module chunks = 1